export const VERSION = '4.78.1'; // x-release-please-version
//# sourceMappingURL=version.mjs.map